import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { ArrowBack as ArrowBackIcon } from "@material-ui/icons";
import { Tab, Tabs, Box, Grid, Paper } from "@material-ui/core";

import translate from "i18n/translate";
import useStyles from "./accountStyles";
import PersonalInfo from "./PersonalInfo";
import Security from "./Security";
import Notification from "./Notification";
import Receipt from "./Receipt";
import { SrButton, Typography } from "../../common";
import { View } from "components/utils";

const TabPanel = ({ children, value, index, ...other }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
};

const Account = () => {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const history = useHistory();

  const navigatePortal = () => {
    history.go(-1);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const a11yProps = (index) => ({
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  });

  return (
    <View translateTitleKey="account.title">
      <Paper elevation={0} className={classes.paper}>
        <Grid container>
          <Grid item xs={12}>
            <SrButton
              startIcon={<ArrowBackIcon color="primary" />}
              onClick={navigatePortal}
            >
              {translate("common.return")}
            </SrButton>
          </Grid>
          <Grid item xs={12}>
            <Box mt={5} mb={3}>
              <Typography variant="h3">{translate("account.title")}</Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              variant="scrollable"
            >
              <Tab
                label={translate("account.personalInfo")}
                {...a11yProps(0)}
              />
              <Tab label={translate("common.security")} {...a11yProps(1)} />
              <Tab label={translate("common.notification")} {...a11yProps(2)} />
              <Tab label={translate("common.receipt")} {...a11yProps(3)} />
            </Tabs>
          </Grid>
          <Grid item xs={12}>
            <Box pt={7}>
              <TabPanel value={value} index={0}>
                <PersonalInfo />
              </TabPanel>
              <TabPanel value={value} index={1}>
                <Security />
              </TabPanel>
              <TabPanel value={value} index={2}>
                <Notification />
              </TabPanel>
              <TabPanel value={value} index={3}>
                <Receipt />
              </TabPanel>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </View>
  );
};

export default Account;
